import {VERSION_3} from '@/constants/constant';

import {AppHelper} from './appHelper';

// eslint-disable-next-line import/prefer-default-export
export function gapFixerClass() {
  console.log({test: AppHelper.version});
  if (AppHelper.version === VERSION_3) return '';
  return 'no-flexbox-gap';
}
